<app-help-page mainVideo="notification-destinations"
               [tutorials]="['notification-destination-email']"
               [videos]="['notification-destinations']"></app-help-page>
